
import { fetchAd, adStat } from "@/utils/api"
import { defineComponent, ref, reactive, onMounted } from "vue"

interface AdData {
    name: string;
    banner: string;
    showBanner: boolean;
    url: string;
    ad?: AdItem;
}
// 广告组件
export default defineComponent({
    name: "AdView",
    props: {
        position: {
            type: String,
            default: '',
        }
    },
    setup(props, { emit }) {
        const position = props.position
        const state = reactive<AdData>({
            name: '',
            banner: '',
            url: '',
            showBanner: false
        })

        const stat = async (type: 1 | 2) => {
            const rsp = await adStat(state.name, type, position)
        }
        const fetchData = async () => {
            const rsp = await fetchAd(position)
            if (rsp.result == 0) {
                state.name = rsp.data.name
                state.banner = rsp.data.banner
                if (state.name && state.banner) {
                    state.showBanner = true
                }
                state.url = rsp.data.url
                if (rsp.data.items.length > 0) {
                    state.ad = rsp.data.items[0]

                    stat(1)
                }
            }
        }
        const clickAd = () => {
            stat(2)
        }
        onMounted(() => {
            const host = window.location.hostname
            if(host == 'localhost' || host == '127.0.0.1') {
                return
            }
            fetchData()
        })
        return {
            state,
            clickAd,
        };
    },
})
